import styled from "styled-components";

export const TwoColumnLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr; /* Two equal-width columns */
    position: relative;
    &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 50%;
        width: 1px;
        background-color: #e1e4ea;
        transform: translateX(-50%);
    }
`;
